export default "__VITE_ASSET__CyvRkPze__"